import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { FONT } from "@styles/common";
import theme from "@styles/theme";
import { StatusBoxProp } from "./types/statusBoxProp";

export const ColorCSS = {
    available: css`
        background-color: ${theme.COLOR.positive[100]};
    `,

    disable: css`
        background-color: ${theme.COLOR.pink[200]};
    `,

    proceed: css`
        background-color: #a4c6df;
    `,

    tel: css`
        background-color: ${theme.COLOR.blue[300]};
    `,
};

export const StyledStatusBox = styled.div<StatusBoxProp>`
    width: 12px;
    height: 12px;
    border-radius: 50%;
    border: none;
    color: white;
    ${FONT("pretnedard", 12, 700, 1.5)};
    text-align: center;
    ${({ status }) => ColorCSS[status]}
`;
